<template>
  <div>
    <el-dialog
      title="产品权限查询"
      custom-class="perm-modal"
      :visible.sync="formVisible"
      width="1100px"
      top="20px"
      :close-on-click-modal="false"
    >
      <div class="perm-modal-table" style="margin-bottom: 12px">
        <div class="flex">
          <product-select
            class="multiple-select"
            style="margin-left: 0px"
            :value.sync="formSearch.afIdList"
            :multiple="true"
            placeholder="请选择产品"
          >
          </product-select>
          <el-select
            class="multiple-select"
            filterable
            collapse-tags
            multiple
            placeholder="请选择平台类型"
            v-model="formSearch.publishPlatformList"
          >
            <el-option
              v-for="item in marketTypeList"
              :key="item.refId"
              :label="item.name"
              :value="item.refId"
            >
            </el-option>
          </el-select>
          <el-select
            filterable
            collapse-tags
            multiple
            class="multiple-select"
            placeholder="请选择工作室"
            v-model="formSearch.groupNameList"
            @change="changeGroupIds"
          >
            <el-option
              v-for="item in groupList"
              :key="item.refId"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <el-select
            filterable
            collapse-tags
            multiple
            class="multiple-select"
            placeholder="请选择小组"
            v-model="formSearch.squadNameList"
          >
            <el-option
              v-for="item in studioList"
              :key="item.refId"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <div>
            <el-button @click="handleReset" style="margin-left: 16px"
              >重置
            </el-button>
            <el-button
              type="primary"
              @click="handleSearch"
              style="margin-left: 16px"
              >查询
            </el-button>
          </div>
        </div>
        <div class="table-group">
          <el-table
            :data="tableData"
            ref="account"
            height="calc(100vh - 365px)"
            style="width: 100%"
            v-loading="tableLoading"
          >
            <el-table-column prop="afid" label="唯一标识"> </el-table-column>
            <el-table-column prop="appName" label="产品名称"> </el-table-column>
            <el-table-column prop="marketTypeName" label="平台类型">
            </el-table-column>
            <el-table-column prop="groupSquadName" label="所属工作室小组">
            </el-table-column>
            <el-table-column prop="sourceName" label="权限来源">
              <template slot="header">
                <span>权限来源</span>
                <el-tooltip
                  placement="top"
                  content="当用户和角色权限都配置时会优先用户权限，如果要以角色权限为主，则需要取消勾选用户权限"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="getCurrentPage"
            @handleSizeChange="changePageSize"
            ref="tabelPagination"
          ></self-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProductPermDetailList } from "@/api/account-management.js";
import { getTagPropertySelectList } from "@/api/property";
import {
  getGroupList,
  getSquadList,
  getProductSimpleList,
} from "@/api/general.js";

export default {
  data() {
    return {
      getProductSimpleList,
      formVisible: false,
      formSearch: {
        afIdList: [],
        publishPlatformList: [],
        groupNameList: [],
        squadNameList: [],
      },
      tableData: [],
      pageData: {
        size: 10,
        page: 1,
        total: 10,
      },
      marketTypeList: [],
      groupList: [],
      studioList: [],
      tableLoading: false,
      editData: {},
    };
  },
  props: {
    refType: Number,
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
  methods: {
    showModal(data) {
      this.editData = data;
      this.tableData = [];
      this.initSelect();
      this.formVisible = true;
    },
    initSelect() {
      getTagPropertySelectList({ type: 10 }).then((res) => {
        this.marketTypeList = res.data;
      });
      getGroupList().then((res) => {
        this.groupList = res.data;
      });
      this.getSquadData();
      this.handleReset();
    },
    getSquadData() {
      getSquadList({
        groupNameList: this.formSearch.groupNameList?.join(","),
      }).then((res) => {
        this.studioList = res.data;
      });
    },
    changeGroupIds() {
      this.formSearch.squadNameList = [];
      this.getSquadData();
    },
    handleReset() {
      this.formSearch = {
        afIdList: [],
        publishPlatformList: [],
        groupNameList: [],
        squadNameList: [],
      };
      this.pageData.page = 1;
      this.getList();
    },
    handleCancel() {
      this.formVisible = false;
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      getProductPermDetailList({
        ...this.formSearch,
        userIdList: [this.editData.id],
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
      }).then((res) => {
        if (res.code == "0000") {
          this.tableData = res.data.list;
          this.pageData.total = res.data.total;
        }
        this.tableLoading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.perm-modal {
  .perm-modal-table {
    width: 100%;
    border-radius: 4px;
    box-sizing: border-box;
    .multiple-select {
      margin-left: 16px;
      width: 200px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .table-group {
      margin-top: 20px;
    }
  }
}
</style>
